import { ReactElement } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { AccessGroupsManagementTable } from 'widgets/AccessGroupsManagementTable';

import { BackButton } from 'shared/ui/BackButton';

import styles from './AccessGroupsManagementPage.module.scss';

function AccessGroupsManagementPage(): ReactElement {
  const { t } = useTranslation('AccessGroup');

  return (
    <section className={styles.rootWrapper}>
      <header className={styles.topContentWrapper}>
        <div className={styles.leftContentHolder}>
          <div className={styles.titleBlock}>
            <BackButton />
            <Typography.Title level={3}>{t('Header.title')}</Typography.Title>
          </div>
        </div>
      </header>
      <div className={styles.mainContentHolder}>
        <AccessGroupsManagementTable />
      </div>
    </section>
  );
}

export default AccessGroupsManagementPage;
